@use '@lib/assets/styles/main.scss' as *;

%bordered {
  padding: 12px 16px;
  &:not(:first-child) {
    border-left: 1px solid $gray100;
  }
}

.head {
  position: sticky;
  top: 0;
  z-index: 1;
  background: $gray0;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    border-bottom: 1px solid $gray100;
    z-index: 2;
  }

  th {
    font-weight: 600;
    padding: 14px 8px;
    vertical-align: top;
    &:first-child {
      padding-left: 24px;
    }
    &.borderedCell {
      @extend %bordered;
    }
  }

  &.tableWithBorderedCells  {
    th {
      @extend %bordered;
    }
  }
}

.headerCellContent {
  white-space: nowrap;
}

.selectCell {
  min-width: 52px;
  width: 1%;
  padding: 0 0 0 4px !important;
  & > label {
    vertical-align: middle;
    margin: -2px 0;
    display: flex;
  }
}

.selectCellCheckbox {
  display: block;
  width: 48px;
}

.actionsCell {
  position: sticky;
  right: 0;
}

.sortingCell {
  cursor: pointer;
}

.singleLineCell {
  white-space: nowrap;
}

.cellTooltipIcon {
  margin-top: -2px;
  padding: 4px;
  cursor: pointer;
  & > i {
    display: block;
    color: $gray400;
  }
}

.flexCellContent {
  display: flex;
  align-items: center;
}

.sortingIcon {
  display: block;
  margin-left: 4px;
  color: $gray400;
}

.sortingIconAsc {
  color: $gray500;
  transform: rotate(-180deg);
}

.sortingIconDesc {
  color: $gray500;
  transform: rotate(0deg);
}
